<template>
  <ul class="com-steps">
    <li
      v-for="(item, index) in steps"
      :key="index"
      :class="['item-step', { inactive: index < active }, { active: index === active }]"
    >
      <span class="idx">
        <i v-if="index < active" class="el-icon-check"></i>
        <b v-else>{{ index + 1 }}</b>
      </span>
      <p>{{ item }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Steps',
  props: {
    active: { type: Number, default: -1 }
  },

  data() {
    return {
      steps: ['学校信息', '设置管理员', '系统配置']
    }
  }
}
</script>

<style lang="scss" scoped>
.com-steps {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  &:before {
    position: absolute;
    top: 15px;
    left: 3em;
    right: 3em;
    content: '';
    height: 1px;
    background-color: #ddd;
  }

  .item-step {
    position: relative;
    width: 6em;
    text-align: center;
    color: #999;
    line-height: 20px;
    font-size: 14px;
    .idx {
      display: inline-block;
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background-color: #ddd;
      font-size: 12px;
      font-weight: bold;
      border-radius: 15px;
      margin-bottom: 8px;
      i {
        font-weight: bold;
      }
    }
    p {
      text-align: center;
    }
  }

  .item-step.active {
    color: #1c67fe;
    font-weight: bold;
    .idx {
      color: #fff;
      background-color: #1c67fe;
    }
  }
}
</style>
